import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';
import LandingPage from './LandingPage';

export default function HomePage() {
  const auth = useAuth();

  // If not authenticated, show landing page
  if (!auth.isAuthenticated || !auth.user) {
    return <LandingPage />;
  }

  // Skip dashboards - redirect all authenticated users to my-library
  return <Navigate to="/my-library" replace />;
}
